import { useTheme } from "@emotion/react";
import { BarTimeChart } from "./bar_time_chart";
import { getBarTimeChartOptions, applyAutoScale } from "./chart_options";

export function LynxChart({ metering, multiDay = false }) {
  const theme = useTheme();
  if (!metering) return;

  const utctime = metering.map((el) => new Date(1000 * el.utctime));
  const box_metering = metering.map((el) => el.grid_box);
  const lynx_metering = metering.map((el) => el.grid_lynx);
  const data = {
    labels: utctime,
    datasets: [
      {
        fill: false,
        label: "Network operator metering",
        data: lynx_metering,
        borderWidth: 2,
        borderColor: theme.palette.lynx.secondary,
        backgroundColor: "transparent",
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        type: "line",
      },
      {
        fill: false,
        label: "Box metering",
        data: box_metering,
        borderWidth: 2,
        borderColor: theme.palette.lynx.main,
        backgroundColor: "transparent",
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        type: "line",
      },
    ],
  };

  const options = getBarTimeChartOptions(multiDay);
  options.scales.x.time = {
    tooltipFormat: "dd/MM/yyyy HH:mm",
    displayFormats: {
      hour: "dd/MM HH:mm",
    },
  };

  options.scales.y = { stacked: false };
  applyAutoScale(options, [lynx_metering, box_metering], "W");

  return <BarTimeChart data={data} options={options} />;
}
